// extracted by mini-css-extract-plugin
export default {"inputBox":"Input_inputBox__5Msms","inputBoxLabel":"Input_inputBoxLabel__L9oKF","validationMsg":"Input_validationMsg__j0pcU"};